/* eslint-disable */
export default {
  dialer: '拨号盘',
  allCalls: '所有通话',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
